import { ConditionType, type IConditionDto, ConditionBase, ConditionState, type IConditionLabelOptions, type IVehicle, ConfigurationType } from "..";

export class ExtendedWarrantyCondition extends ConditionBase
{

    constructor( vehicle: IVehicle, model: IConditionDto )
    {
        super( vehicle, model, ConditionType.Wash, ConfigurationType.Weekly, false );
        this.icon = 'help-me:service';
        this.ordinal = -1;
        this.initialise();
    }

    /**
     * Gets the labels for the condition.  The labels are used to provide meaningful
     * user interface statements/prompts that are specific to the condition
     */
    override getLabels(): IConditionLabelOptions 
    {
        return {
            name: "Extended Warranty",
            shortName: 'Extended Warranty',
            longName: "Extended Warranty",
            intervalJustCompletedMessage: "Your extended warranty has just been updated",
            cta: " ",
            maintenanceVerb: 'Extended Warranty',
            protectedByLabel: 'Your car is covered by'
        };
    }

    /**
     * Gets the description for the interval update for this condition
     * @returns 
     */
    protected override getIntervalDescription()
    {
        if( this.averageOdometerInterval == 0 ) return 'n/a';
        return `Keep your extended warranty up to date`;
    }

    // override getDateRelativeLabel()
    // {
        
    //     // Hard-coded for demo purposes
    //     return "Coming Up";
    // }

    /**
     * Gets the action message for the service note
     */
    override getActionMessage() 
    {
        switch( this.state )
        {
            case ConditionState.Due: return "Your Extended Warranty is ending soon, contact your dealer to see if you are eligible to extend your cover";
            case ConditionState.Overdue: return "Your Extended Warranty has expired";
            case ConditionState.Critical: return "";
            default: return "";
        }
    }
    
}
